var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvaluate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.029,
    height: 102.529,
    viewBox: "0 0 102.029 102.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M5.268,3H55.941L81.463,27.254V96.329a4.476,4.476,0,0,1-4.477,4.477H6.052A3.053,3.053,0,0,1,3,97.754V5.268A2.269,2.269,0,0,1,5.268,3Z",
    fill: "none",
    stroke: "#ff9d79",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M44.36,27l3.61,6.332a1.009,1.009,0,0,0,1.5.289L65.24,21.07",
    transform: "translate(-24.276 -10.606)",
    fill: "none",
    stroke: "#ff9d79",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M132.83,6.13V27.72a2.846,2.846,0,0,0,2.846,2.846h21.987",
    transform: "translate(-76.204 -1.837)",
    fill: "none",
    stroke: "#ff9d79",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 34.486,
    height: 28.633,
    rx: 6.13,
    transform: "translate(11.224 29.84)",
    fill: "none",
    stroke: "#ff9d79",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 34.486,
    height: 28.633,
    rx: 6.13,
    transform: "translate(11.224 65.077)",
    fill: "none",
    stroke: "#ff9d79",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M54.628,88.241l5.386.632a.388.388,0,0,1,.231.657L56.47,93.42a.386.386,0,0,0-.1.347l1.066,5.316a.391.391,0,0,1-.553.425l-4.866-2.392a.382.382,0,0,0-.359.008l-4.729,2.656a.388.388,0,0,1-.574-.392l.768-5.37A.4.4,0,0,0,47,93.68L43.013,90a.39.39,0,0,1,.2-.669l5.341-.929a.387.387,0,0,0,.285-.219L51.1,83.259a.387.387,0,0,1,.694-.021l2.532,4.8a.378.378,0,0,0,.3.2Z",
    transform: "translate(-23.412 -46.976)",
    fill: "none",
    stroke: "#ff9d79",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M54.628,175.191l5.386.632a.388.388,0,0,1,.231.657L56.47,180.37a.386.386,0,0,0-.1.347l1.066,5.316a.391.391,0,0,1-.553.425l-4.866-2.392a.382.382,0,0,0-.359.008l-4.729,2.656a.388.388,0,0,1-.574-.392l.768-5.37a.4.4,0,0,0-.12-.339l-3.986-3.676a.39.39,0,0,1,.2-.669l5.341-.929a.387.387,0,0,0,.285-.219l2.264-4.928a.387.387,0,0,1,.694-.021l2.532,4.8a.378.378,0,0,0,.3.2Z",
    transform: "translate(-23.412 -98.011)",
    fill: "none",
    stroke: "#ff9d79",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 48.149,
    height: 48.149,
    rx: 24.075,
    transform: "translate(53.88 54.379)",
    fill: "#f5f5f5",
    stroke: "#ff9d79",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 6.923,
    cy: 6.923,
    r: 6.923,
    transform: "translate(71.41 61.426)",
    fill: "none",
    stroke: "#ff9d79",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M160.884,186.89h5.931a10.247,10.247,0,0,1,10.244,10.244v2.648H150.64v-2.648A10.247,10.247,0,0,1,160.884,186.89Z",
    transform: "translate(-86.657 -107.934)",
    fill: "none",
    stroke: "#ff9d79",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluate);
export default __webpack_public_path__ + "static/media/evaluate.2f0f44c83cafa4d2ea0e2d4ec7c3c84c.svg";
export { ForwardRef as ReactComponent };